import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, Stack, TextField } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { getCustomerDetail, regCustomerMemo } from "../../Api/Customer";
import { CustomerDetailInterface, CustomerMemo, ObjectToCustomerMemo } from "../../Objects/Customer";
import CustomerCard from "../molecules/CustomerCard";

export interface CustomerMemoEditDialogProps {
    ctmId?: number
    dialogProps?: Omit<DialogProps, "open">
    onClose: () => void
}
export function CustomerMemoEditDialog({
    ctmId,
    dialogProps,
    onClose,
}: CustomerMemoEditDialogProps): React.ReactElement {
    let { enqueueSnackbar } = useSnackbar()

    const [open, setOpen] = React.useState<boolean>(false)

    const [customerDetailData, setCustomerDetailData] = React.useState<CustomerDetailInterface>()

    const [editCustomerMemo, setEditCustomerMemo] = React.useState<CustomerMemo[]>()

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const doSave = React.useCallback(() => {
        if (ctmId && editCustomerMemo) {
            //validate
            // @todo
            regCustomerMemo({
                ctm_id: ctmId,
                ctm_memo: editCustomerMemo,
            }, {signal: abortController.signal}).then(() => {
                enqueueSnackbar("登録しました", { variant: "success" })
                setOpen(false)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
    }, [abortController, ctmId, editCustomerMemo, enqueueSnackbar])

    React.useEffect(() => {
        const controller = new AbortController()
        if (ctmId) {
            getCustomerDetail({
                accessKey: "HEAD-OFFICE_LOGIN",
                ctmId: ctmId
            }, {signal: controller.signal}).then(result => {
                setCustomerDetailData(result)
                const customerMemo: CustomerMemo[] = Object.entries(result.ctm_memo).map((value: [string, string]) => {
                    return ObjectToCustomerMemo(value)
                })
                setEditCustomerMemo(customerMemo);
                setOpen(true)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
        return () => {
            controller.abort()
        }
    }, [ctmId, enqueueSnackbar])

    return (
        <Dialog
            {...dialogProps}
            open={open}
            onClose={() => {
                setOpen(false)
            }}
            TransitionProps={{
                onExited: () => {
                    onClose()
                }
            }}
        >
            <DialogTitle>メモ編集</DialogTitle>
            {customerDetailData &&
                <DialogContent>
                    <CustomerCard
                        customer={customerDetailData}
                    />
                    <Grid container
                        spacing={1}
                        rowSpacing={2}
                        mt={1}
                    >
                        {editCustomerMemo && editCustomerMemo.map((ctmMemo, index) => (
                            <Grid item key={index} xs={12}>
                                <TextField
                                    multiline
                                    fullWidth
                                    rows={3}
                                    value={ctmMemo.ctm_memo}
                                    onChange={e => {
                                        const _customerMemo: CustomerMemo[] = editCustomerMemo.map(value => {
                                            return {
                                                ctmmm_id: value.ctmmm_id,
                                                ctm_memo: value.ctmmm_id === ctmMemo.ctmmm_id ? e.target.value : value.ctm_memo
                                            }
                                        })
                                        setEditCustomerMemo(_customerMemo)
                                    }}
                                />
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <Stack
                                direction={"row"}
                                justifyContent={"center"}
                            >
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setEditCustomerMemo(_customerMemo => {
                                            const add: CustomerMemo[] = [{
                                                ctmmm_id: 0,
                                                ctm_memo: ""
                                            }]
                                            if (!_customerMemo) {
                                                return add
                                            } else {
                                                return _customerMemo.concat(add)
                                            }
                                        })
                                    }}
                                >メモを追加</Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </DialogContent>
            }
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setOpen(false)
                    }}
                >キャンセル</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        doSave()
                    }}
                >保存</Button>
            </DialogActions>
        </Dialog>
    )
}